import { SenderID } from '@business/entities/sender';
import { TicketEmailsResponse } from './TicketEmailsResponse';
import { TicketFileResponse } from './TicketFileResponse';

export type TicketReplyId = string;

export enum TicketReplyResponseType {
  response = 'response',
  internalNote = 'internal_note',
  responded = 'responded',
  sendAndClosed = 'send_closed',
  closed = 'closed',
  createTicket = 'create_ticket',
}

export enum TicketReplyResponseKind {
  reply = 'reply',
  forward = 'forward',
  internal = 'internal',
}

export interface TicketReplyResponse {
  id: TicketReplyId;
  responseType: TicketReplyResponseType;
  replyTo: TicketEmailsResponse[];
  replyCc: TicketEmailsResponse[];
  replyBcc: TicketEmailsResponse[];
  replyFrom: string;
  fromName: string;
  fromEmail: string;
  body: string;
  htmlBody: string;
  createdAt: number;
  updatedAt: number;
  files: TicketFileResponse[];
  emails: TicketEmailsResponse[];
}

export type TicketReplyRequest = {
  body: string;
  responseType: TicketReplyResponseType;
  signature?: boolean;
  replyTo?: string[];
  replyCc?: string[];
  replyBcc?: string[];
  file?: File[];
  senderId?: SenderID;
};
